<template>
  <div class="c-library-page" v-if="isAuth" @scroll="onScroll">
    <DeactivatedEmptyState v-if="isDeactivated" title="Library"></DeactivatedEmptyState>
    <Library v-else ref="library"></Library>
  </div>
</template>

<script>
import Library from "@swipekit/components/library";
import DeactivatedEmptyState from "@/components/deactivated-empty-state.vue";

export default {
  components: {
    Library,
    DeactivatedEmptyState,
  },

  computed: {
    isAuth: function () {
      return this.$store.getters["users/isAuth"];
    },
    isDeactivated: function () {
      return this.$store.getters["users/isTrialOver"];
    },
  },

  methods: {
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      let buffer = 100;
      if (scrollTop + clientHeight >= scrollHeight - buffer) {
        //this.$refs.library.onEnd();
      } else {
      }
    },
  },
};
</script>

<style lang="scss">
.c-library-page {
  // height: 100vh;
  // position: relative;
  // overflow-y: auto;
}
</style>
